module.exports = __webpack_public_path__ + "img/p4.17785063.png";